module.exports = __webpack_public_path__ + "img/gg.8a2fc09a.png";